import { toast } from 'react-toastify';
import { getOpenSourceData } from '../../services/open-source/open-source-service';
import { useState } from 'react';
import { IOpenSourceDetails } from '../../types/stateTypes';

export const OpenSourceHook = () => {
  const [openSourceList, setOpenSourceList] = useState<IOpenSourceDetails[]>();

  const fetchData = async () => {
    try {
      document.getElementById('loading')?.classList.add('manual-loading');
      const faqData = await getOpenSourceData();
      setOpenSourceList(faqData.Data['open-source'] || []);
    } catch (error) {
      toast.error(error.response?.message || error.toString());
    } finally {
      document.getElementById('loading')?.classList.remove('manual-loading');
    }
  };

  return {
    fetchData,
    openSourceList,
  };
};
